import React from 'react';
import { Container, Row, Col } from '@geberit/gdds';

// style
import styles from './breadcrumb.module.scss';

// utils
import { gridSizes, buildSize } from 'utils/gridSize';
import { classNameBuilder as classNamesBuilder } from 'utils/classNameBuilder';
import { isEmpty } from 'utils/is-empty';
import { useGroup } from 'utils/hooks/use-group';
import { Breadcrumbs } from '../App/gdds-breadcrumbs/breadcrumbs';
import { useNord } from 'utils/hooks/use-nord';

type GddsBreadcrumbProps = {
  items: Partial<Breadcrumb>[];
  className?: string;
};

export default function GddsBreadcrumb({ items, className }: Readonly<GddsBreadcrumbProps>) {
  const isGroup = useGroup();
  const isNord = useNord();

  if (isEmpty(items)) return null;

  return (
    <Container
      className={classNamesBuilder(
        styles.breadcrumb,
        className ?? '',
        styles.gdds,
        !isGroup && isNord && 'nord',
        !isGroup && isNord && styles.nord,
      )}
      maxContentWidth={buildSize(gridSizes[!isGroup ? 'gddsFullGrid' : 'full'])}
    >
      <Row>
        <Col>
          <Breadcrumbs items={items} />
        </Col>
      </Row>
    </Container>
  );
}
